import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { waLink, WA_DEFAULT_MSG } from "../lib/site";

export const WhatsAppFloat = () => {
  const [showTip, setShowTip] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setShowTip(true), 3500);
    const t2 = setTimeout(() => setShowTip(false), 11000);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  return (
    <div className="fixed bottom-5 left-5 z-50 flex items-center gap-3">
      {showTip && (
        <span className="hidden sm:block text-xs bg-[#101218] border border-white/10 text-slate-200 rounded-xl px-3 py-2 shadow-xl">
          استشر مختص الحساسات مباشرة
        </span>
      )}
      <a
        href={waLink(WA_DEFAULT_MSG)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        aria-label="تواصل عبر واتساب"
        className="whatsapp-glow w-14 h-14 rounded-full bg-emerald-600 hover:bg-emerald-500 flex items-center justify-center text-white transition-all hover:scale-105 active:scale-95"
      >
        <MessageCircle size={26} />
      </a>
    </div>
  );
};
